import cheats from './cheats';
import onLogin from './onLogin';
import settings from './settings';
import users from './users';
import ab from './ab';
import heartbeat from './heartbeat';
import platformStorage from './platformStorage';
import { Pet } from '../buruburu/pet';
import { PetChatbot } from '../buruburu/petChatbot';
import { Conversation } from '../conversation';
import { Care } from '../buruburu/care';
import { Tutorial } from '../buruburu/tutorial';
import { Social } from '../social';
import { Inventory } from '../buruburu/inventory';
import { Profile } from '../profile';
import { Admin } from '../admin';
import { Gifts } from '../buruburu/gifts';
import { Match3 } from '../minigame/match3';
import { Minigame } from '../minigame';
import { Level } from '../buruburu/level';
import { Encyclopedia } from '../encyclopedia';
import { Visit } from '../visit';
import { Iap } from '../iap';
import { Duo } from '../duo';
import { Native } from '../native';

export default {
  ...Pet.actions,
  ...PetChatbot.actions,
  ...Conversation.actions,
  ...Care.actions,
  ...Tutorial.actions,
  ...Social.actions,
  ...Inventory.actions,
  ...Profile.actions,
  ...Admin.actions,
  ...Gifts.actions,
  ...Minigame.actions,
  ...Match3.actions,
  ...Level.actions,
  ...Encyclopedia.actions,
  ...Visit.actions,
  ...Iap.actions,
  ...Duo.actions,
  ...Native.actions,

  ...heartbeat,
  ...ab,
  ...onLogin,
  ...settings,
  ...users,
  ...platformStorage,

  ...(process.env.IS_DEVELOPMENT ? cheats : null),
};
